const compare = (a, b) => a.localeCompare(b, "de", { numeric: true, sensitivity: "base" });
// One existing name field: support both "Vorname Nachname" and "Nachname, Vorname".
const surname = name => name.includes(",") ? name.split(",")[0].trim() : name.split(/\s+/).pop() || "";
export function comparePassengerNames(a, b) {
  const first = String(a || "").trim(), second = String(b || "").trim();
  return compare(surname(first), surname(second)) || compare(first, second);
}
